import {
    Donee,
    FaithLeader,
    MailingAddress,
    PrimaryRepresentative,
} from '@givelify/api';
import { ImageWithDimensions } from '@givelify/onboarding';
import { Dayjs } from 'dayjs';
import {
    SetDoneeAndCampuses,
    SET_DONEE_AND_CAMPUSES,
    SetDonee,
    SET_DONEE,
    SET_DONEE_CUSTOM_RECEIPT,
    SetDoneeCustomReceipt,
    SetDoneeMissionStatement,
    SET_DONEE_MISSION_STATEMENT,
    SET_DONEE_ADDRESS,
    SetDoneeAddress,
    SET_DONEE_MAILING_ADDRESS,
    SetDoneeMailingAddress,
    SET_DONEE_CONTACT,
    SetDoneeContact,
    SET_DONEE_SOCIAL,
    SetDoneeSocial,
    SET_DONEE_FAITH_LEADER,
    SetDoneeFaithLeader,
    REMOVE_DONEE_FAITH_LEADER,
    RemoveDoneeFaithLeader,
    SET_DONEE_ORGANIZATION_LOGO,
    SetDoneeOrganizationLogo,
    SET_DONEE_BANNER_IMAGE,
    SetDoneeBannerImage,
    SET_DONEE_PRIMARY_REP,
    SetDoneePrimaryRep,
    SET_DONEE_ACCOUNT_OWNER,
    AccountOwnerInfo,
    SetDoneeAccountOwner,
    SetDoneeOnboardingStatus,
    SET_DONEE_ONBOARDING_STATUS,
    SET_DONOR_RECOGNITION_STATUS,
    SetDonorRecognitionStatus,
} from './types';

export const setDoneeAndCampuses = (
    donee: Donee,
    campuses: Donee[],
): SetDoneeAndCampuses => ({
    type: SET_DONEE_AND_CAMPUSES,
    donee,
    campuses,
});

export const setDonee = (donee: Donee): SetDonee => ({
    type: SET_DONEE,
    donee,
});

export const setDoneeCustomReceipt = (
    doneeId: number,
    customReceipt: boolean,
    updatedAt: Dayjs,
): SetDoneeCustomReceipt => ({
    doneeId,
    type: SET_DONEE_CUSTOM_RECEIPT,
    customReceipt,
    updatedAt,
});

export const setDoneeMissionStatement = (
    doneeId: number,
    missionStatement: string,
    updatedAt: Dayjs,
): SetDoneeMissionStatement => ({
    type: SET_DONEE_MISSION_STATEMENT,
    doneeId,
    missionStatement,
    updatedAt,
});

export const setDoneeAddress = (
    doneeId: number,
    address: string,
    city: string,
    state: string,
    zip: string,
    phone: string,
    updatedAt: Dayjs,
    timezoneLong: string,
    timezoneShort: string,
    timezone: string,
): SetDoneeAddress => ({
    type: SET_DONEE_ADDRESS,
    doneeId,
    address,
    city,
    state,
    zip,
    phone,
    updatedAt,
    timezoneLong,
    timezoneShort,
    timezone,
});

export const setDoneeMailingAddress = (
    doneeId: number,
    mailingAddress: MailingAddress | null,
    updatedAt: Dayjs,
): SetDoneeMailingAddress => ({
    type: SET_DONEE_MAILING_ADDRESS,
    doneeId,
    mailingAddress,
    updatedAt,
});

export const setDoneeContact = (
    doneeId: number,
    phone: string,
    email: string,
    established: number,
    congregationSize: string,
    denomination: string,
    updatedAt: Dayjs,
): SetDoneeContact => ({
    type: SET_DONEE_CONTACT,
    doneeId,
    phone,
    email,
    established,
    congregationSize,
    denomination,
    updatedAt,
});

export const setDoneeSocial = (
    doneeId: number,
    facebook: string,
    instagram: string,
    twitter: string,
    website: string,
    updatedAt: Dayjs,
): SetDoneeSocial => ({
    type: SET_DONEE_SOCIAL,
    doneeId,
    facebook,
    instagram,
    twitter,
    website,
    updatedAt,
});

export const setDoneeFaithLeader = (
    faithLeaderInfo: FaithLeader | undefined,
    updatedAt: Dayjs,
): SetDoneeFaithLeader => ({
    type: SET_DONEE_FAITH_LEADER,
    faithLeaderInfo,
    updatedAt,
});

export const removeDoneeFaithLeader = (
    updatedAt: Dayjs,
): RemoveDoneeFaithLeader => ({
    type: REMOVE_DONEE_FAITH_LEADER,
    updatedAt,
});

export const setDoneeAccountOwner = (
    accountOwnerInfo: AccountOwnerInfo,
    updatedAt: Dayjs,
): SetDoneeAccountOwner => ({
    type: SET_DONEE_ACCOUNT_OWNER,
    accountOwnerInfo,
    updatedAt,
});

export const setDoneeOrganizationLogo = (
    logo: ImageWithDimensions,
): SetDoneeOrganizationLogo => ({
    type: SET_DONEE_ORGANIZATION_LOGO,
    logo,
});

export const setDoneeBannerImage = (
    image: ImageWithDimensions,
): SetDoneeBannerImage => ({
    type: SET_DONEE_BANNER_IMAGE,
    image,
});

export const setDoneePrimaryRep = (
    primaryRepInfo: PrimaryRepresentative,
): SetDoneePrimaryRep => ({
    type: SET_DONEE_PRIMARY_REP,
    primaryRepInfo,
});

export const setDoneeOnboardingStatus = (
    value: boolean,
): SetDoneeOnboardingStatus => ({
    type: SET_DONEE_ONBOARDING_STATUS,
    value,
});

export const setDonorRecognitionStatus = (
    value: boolean,
): SetDonorRecognitionStatus => ({
    type: SET_DONOR_RECOGNITION_STATUS,
    value,
});
